module.exports = __webpack_public_path__ + "static/media/JST_Web.1c695bb6.svg";